import { Link } from 'react-router-dom';

const LANDLORD_BENEFITS = [
  { icon: 'ri-file-text-line',         color: 'text-amber-400',   title: 'AI 標題生成',   desc: '10 秒產出多個吸睛標題，點閱率翻倍' },
  { icon: 'ri-shield-check-line',      color: 'text-green-400',   title: 'AI 租客審核',   desc: '一鍵分析租客可信度，風險提前掌握' },
  { icon: 'ri-megaphone-line',         color: 'text-orange-400',  title: 'AI 推廣文案',   desc: '自動生成 Threads / Facebook 貼文' },
  { icon: 'ri-bar-chart-box-line',     color: 'text-rose-400',    title: 'AI 實價分析',   desc: '周邊行情即時比對，定價有數據依據' },
];

const TENANT_BENEFITS = [
  { icon: 'ri-sparkling-2-fill',       color: 'text-teal-400',    title: 'AI 智能配對',   desc: '依需求媒合最適房源，不用慢慢篩' },
  { icon: 'ri-robot-2-line',           color: 'text-emerald-400', title: 'AI 即時問答',   desc: '24 小時秒答房源問題，聯絡前就掌握' },
];

export default function AiBenefitsSection() {
  return (
    <section className="max-w-5xl mx-auto px-4 pb-14">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-white/6 border border-white/10 rounded-full text-[10px] font-bold text-white/50 mb-3">
          <i className="ri-user-2-line text-xs"></i>
          適合對象
        </div>
        <h2 className="text-xl md:text-2xl font-black text-white">不管你是誰，AI 都幫得上忙</h2>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {/* 屋主 */}
        <div className="rounded-2xl border border-amber-500/20 overflow-hidden" style={{ background: 'linear-gradient(135deg, rgba(251,191,36,0.06) 0%, rgba(0,0,0,0) 60%), rgba(255,255,255,0.03)' }}>
          <div className="flex items-center gap-3 px-5 py-4 border-b border-amber-500/15">
            <div className="w-10 h-10 rounded-xl bg-amber-500/20 border border-amber-500/25 flex items-center justify-center flex-shrink-0">
              <i className="ri-home-4-line text-amber-400 text-lg"></i>
            </div>
            <div>
              <p className="text-sm font-black text-white">我是屋主</p>
              <p className="text-[10px] text-amber-400/70">發布房源 · 篩選租客 · 推廣行銷</p>
            </div>
            <span className="ml-auto text-[9px] font-black px-2 py-0.5 rounded-full bg-amber-500/20 border border-amber-500/30 text-amber-300 whitespace-nowrap">4 項 AI 功能</span>
          </div>
          <div className="p-4 space-y-2.5">
            {LANDLORD_BENEFITS.map((b) => (
              <div key={b.title} className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-lg bg-white/6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${b.icon} text-sm ${b.color}`}></i>
                </div>
                <div>
                  <p className="text-xs font-bold text-white">{b.title}</p>
                  <p className="text-[11px] text-white/40 mt-0.5 leading-snug">{b.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="px-4 pb-4">
            <Link to="/publish"
              className="flex items-center justify-center gap-2 py-2.5 bg-amber-500 hover:bg-amber-400 text-white text-xs font-bold rounded-xl transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-add-circle-line"></i>立即發布房源
            </Link>
          </div>
        </div>

        {/* 租客 */}
        <div className="rounded-2xl border border-teal-500/20 overflow-hidden" style={{ background: 'linear-gradient(135deg, rgba(45,212,191,0.06) 0%, rgba(0,0,0,0) 60%), rgba(255,255,255,0.03)' }}>
          <div className="flex items-center gap-3 px-5 py-4 border-b border-teal-500/15">
            <div className="w-10 h-10 rounded-xl bg-teal-500/20 border border-teal-500/25 flex items-center justify-center flex-shrink-0">
              <i className="ri-search-2-line text-teal-400 text-lg"></i>
            </div>
            <div>
              <p className="text-sm font-black text-white">我是租客</p>
              <p className="text-[10px] text-teal-400/70">尋找房源 · AI 配對 · 即時詢問</p>
            </div>
            <span className="ml-auto text-[9px] font-black px-2 py-0.5 rounded-full bg-teal-500/20 border border-teal-500/30 text-teal-300 whitespace-nowrap">2 項 AI 功能</span>
          </div>
          <div className="p-4 space-y-2.5">
            {TENANT_BENEFITS.map((b) => (
              <div key={b.title} className="flex items-start gap-3">
                <div className="w-7 h-7 rounded-lg bg-white/6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${b.icon} text-sm ${b.color}`}></i>
                </div>
                <div>
                  <p className="text-xs font-bold text-white">{b.title}</p>
                  <p className="text-[11px] text-white/40 mt-0.5 leading-snug">{b.desc}</p>
                </div>
              </div>
            ))}
            <div className="mt-1 p-3 rounded-xl border border-teal-500/15 bg-teal-500/5">
              <div className="flex items-center gap-2 mb-1">
                <i className="ri-time-line text-teal-400 text-sm"></i>
                <p className="text-xs font-bold text-teal-300">更多功能即將推出</p>
              </div>
              <p className="text-[11px] text-white/35 leading-snug">AI 租屋助手、個人化推薦、行情通知等功能正在開發中</p>
            </div>
          </div>
          <div className="px-4 pb-4">
            <Link to="/ai-match"
              className="flex items-center justify-center gap-2 py-2.5 bg-teal-500 hover:bg-teal-400 text-white text-xs font-bold rounded-xl transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-sparkling-2-fill"></i>立即 AI 配對找房
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
